import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import DeleteOrderButton from "../DeleteOrderButton";
import { useUser } from "../../contexts";

const ViewOrderHeader = ({ orderId }: { orderId: string }) => {
  const history = useHistory();
  const [{ user }] = useUser();
  const { t } = useTranslation();
  return (
    <div className="row row-column-phone-responsive row-space-between address-details">
      <p className="section-title">
        {t("order")} {orderId}
      </p>

      {user && !user.name && (
        <DeleteOrderButton
          orderId={orderId}
          onDelete={() => history.push("/dashboard")}
        />
      )}
    </div>
  );
};

export default ViewOrderHeader;
